import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, CircularProgress } from '@material-ui/core';
import { DocumentFileIcon, DragIcon, HideIcon } from '@room-match/shared-ui-components';
import { useState } from 'react';
import { IProfileMedia } from 'shared/interfaces/IProfile';
import { goToLink } from 'shared/utils/goToLink';
import { CheckNumberCont } from '../item.styles';
import { DocumentContainer, DocumentIconContainer, DocumentName } from './Document.styles';

type DocumentItemProps = {
  document: IProfileMedia;
  handleCheck: VoidFunction;
  isAllowed?: boolean;
  index: number;
};

export const DocumentItem = ({ document, handleCheck, isAllowed, index }: DocumentItemProps) => {
  const attachment =
    document?.attributes?.attachment ||
    document?.attributes?.cropped_attachment ||
    document?.attributes?.modified_attachment;

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: document.id || document?.attributes?.medium_id,
    animateLayoutChanges: () => false,
    transition: {
      duration: 500,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1,
  };

  const [clicked, setClicked] = useState(false);
  const [hovering, setHovering] = useState(false);

  const handleChange = (e: any) => {
    e.stopPropagation();
    if (isAllowed) {
      setClicked((prev) => !prev);
    }
    handleCheck();
  };

  return (
    <DocumentContainer
      ref={setNodeRef}
      style={{ ...style, pointerEvents: clicked ? 'none' : undefined }}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onClick={() => {
        if (isDragging) return;
        goToLink(attachment);
      }}
    >
      <DocumentIconContainer {...attributes} {...listeners} style={{ cursor: 'move' }}>
        {hovering || isDragging ? (
          <div>
            <DragIcon />
          </div>
        ) : (
          <DocumentFileIcon />
        )}
      </DocumentIconContainer>
      <DocumentName>{document?.attributes?.medium_name}</DocumentName>
      <Box style={{ textAlign: 'end' }}>
        {clicked ? (
          <CircularProgress style={{ marginRight: 4 }} size={20} />
        ) : (
          <Box>
            <CheckNumberCont>
              {hovering ? <HideIcon onClick={handleChange} /> : <span>{index + 1}</span>}
            </CheckNumberCont>
          </Box>
        )}
      </Box>
    </DocumentContainer>
  );
};
